import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { AGENCY_PUBLISHERS_LIST_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds';
import { SettingsLinkRow } from './SettingsLinkRow';
export const AgencyPanel = () => (<div>
		<h3 className="mb-1 text-sm font-semibold">Agency</h3>
		<p className="mb-4 text-xs text-muted-foreground">Manage your publishers and account managers.</p>
		<div className="space-y-2">
			<SettingsLinkRow label="Publisher list" description="Publishers you manage" routeId={AGENCY_PUBLISHERS_LIST_ROUTE_ID} Icon={StorefrontIcon}/>
			<SettingsLinkRow label="Account managers list" description="Your account managers" href="/nova/account-managers" Icon={SupervisorAccountIcon}/>
		</div>
	</div>);
